import service from './../utils/server'
const modName = '/common/web/select/';
/**
 * 用户类型
 * @param data
 */
export const userType = data => {
    return service({
        url: modName + 'userType',
        method: 'post',
        data
    })
};

//不包含承运商的用户类型
export const nonCarrierUserType = data => {
  return service({
    url: modName + 'nonCarrierUserType',
    method: 'post',
    data
  })
};

/**
 * 角色
 */
export const selectRole = data => {
  return service({
    url: modName + 'roleInfo',
    method: 'post',
    data
  })
};


//角色数据
export const getRoleInfo = data => {
  return service({
    url: modName + 'roleInfo',
    method: 'post',
    data
  })
};

//模块类型
export const getCategory = data => {
  return service({
    url: modName + 'category',
    method: 'post',
    data
  })
};

//communityInfo
export const getCommunityInfo = data => {
  return service({
    url: modName + 'communityInfo',
    method: 'post',
    data
  })
};

//termsStatusInfo
export const getTermsStatusInfo = data => {
  return service({
    url: modName + 'termsStatusInfo',
    method: 'post',
    data
  })
};

//standardDataTypeInfo
export const getStandardDataTypeInfo = data => {
  return service({
    url: modName + 'standardDataTypeInfo',
    method: 'post',
    data
  })
};

//groupInfo
export const getGroupInfo = data => {
  return service({
    url: modName + 'groupInfo',
    method: 'post',
    data
  })
};

/**
 * 我的消费资产-申请状态
 * @param data
 * @returns {*}
 */
export const getOrderStatus = data => {
  return service({
    url: modName + 'orderStatus',
    method: 'post',
    data
  })
};

/**
 * 发起资产的消费服务申请-查询条件操作符
 * @param data
 * @returns {*}
 */
export const getOperator = data => {
  return service({
    url: modName + 'operator',
    method: 'post',
    data
  })
};

/**
 * 发起资产的消费服务申请-到期状态
 * @param data
 * @returns {*}
 */
export const getOrderExpirationStatus = data => {
  return service({
    url: modName + 'orderExpirationStatus',
    method: 'post',
    data
  })
};

/**
 * 规则下拉框
 * @param data
 * @returns {*}
 */
export const getRuleData = data => {
  return service({
    url: modName + 'dataQualityRule',
    method: 'post',
    data
  })
};

//企业
export const listComp = data => {
  return service({
    url: modName + 'listComp',
    method: 'post',
    data
  })
};

//货主
export const listHz = data => {
  return service({
    url: modName + 'listHz',
    method: 'post',
    data
  })
};

//3PL
export const listPl = data => {
  return service({
    url: modName + 'listPl',
    method: 'post',
    data
  })
};

//承运商
export const listCarrier = data => {
  return service({
    url: modName + 'listCarrier',
    method: 'post',
    data
  })
};



//企业
export const listAddr = data => {
  return service({
    url: modName + 'listAddr/'  + data,
    method: 'post',
    data
  })
};

//区域
export const listArea = data => {
  return service({
    url: modName + 'listArea',
    method: 'post',
    data
  })
};

//项目
export const listProject = data => {
  return service({
    url: modName + 'listProject',
    method: 'post',
    data
  })
};
//货主对应的项目
export const listShipperProject = data => {
  return service({
    url: modName + 'listShipperProject',
    method: 'post',
    data
  })
};
//订单导入的项目
export const listOrderImportProject = data => {
  return service({
    url: modName + 'listOrderImportProject',
    method: 'post',
    data
  })
};


//运输方式
export const listShipType = data => {
  return service({
    url: modName + 'listShipType',
    method: 'post',
    data
  })
};

//机构
export const listCompany = data => {
  return service({
    url: modName + 'listCompany',
    method: 'post',
    data
  })
};

//货主
export const listShipper = data => {
  return service({
    url: modName + 'listShipper',
    method: 'post',
    data
  })
};

//模版类型
export const listTemplateTypeCode = data => {
  return service({
    url: modName + 'listTemplateTypeCode',
    method: 'post',
    data
  })
};


//区域-树形结构
export const areaTree = data => {
  return service({
    url: modName + 'areaTree',
    method: 'post',
    data
  })
};

/**
 * 获取车辆信息
 * @param data
 * @returns {*}
 */
export const getTruckListByCarrierNo = data => {
  return service({
    url: modName + 'getTruckListByCarrierNo',
    method: 'post',
    data
  })
};

/**
 * 获取司机信息
 * @param data
 * @returns {*}
 */
export const getDriverListByCarrierNo = data => {
  return service({
    url: modName + 'getDriverListByCarrierNo',
    method: 'post',
    data
  })
};
/**
 * 获取车辆类型信息
 * @param data
 * @returns {*}
 */
export const getCarTypeList = data => {
  return service({
    url: modName + 'getCarTypeList',
    method: 'post',
    data
  })
};

/**
 * 承运商
 * @param data
 * @returns {*}
 */
export const getListCarrier = data => {
  return service({
    url: modName + 'listCarrier',
    method: 'post',
    data
  })
};

/**
 * 运输方式
 * @param data
 * @returns {*}
 */
export const getListShipType = data => {
  return service({
    url: modName + 'listShipType',
    method: 'post',
    data
  })
};

/**
 * 分拨点
 * @param data
 * @returns {*}
 */
export const getCarrierDpList = data => {
  return service({
    url: modName + 'getCarrierDpList',
    method: 'post',
    data
  })
};

export const listCompanyByShipperCode = data => {
  return service({
    url: modName + 'listCompanyByShipperCode/' + data.shipperCode,
    method: 'post',
  })
};

//发货方
export const listOrigin = data => {
  return service({
    url: modName + 'listOrigin',
    method: 'post',
    data
  })
};

//收货方
export const listDest = data => {
  return service({
    url: modName + 'listDest',
    method: 'post',
    data
  })
};

//企业主体信息
export const getEntity = data => {
  return service({
    url: modName + 'getEntity',
    method: 'post',
    data
  })
};


//车牌颜色
export const getPlateColor = data => {
  return service({
    url: modName + 'getPlateColor',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/api/selects.js